import React from 'react';
import { makeStyles, Theme, Box } from '@material-ui/core';
import intl from 'react-intl-universal';

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    width: '100%',
    maxWidth: 1180
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 'auto',
    paddingTop: theme.spacing(2),
    '@media (max-width: 50rem)': {
      flexDirection: 'column'
    }
  },
  needHelpContainer: {
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '18px',
    letterSpacing: '2px',
    color: '#201727'
  },
  logo: {
    height: 40
  },
  link: {
    color: theme.palette.primary.main
  }
}));

export default function Header() {
  const classes = useStyles();
  return (
    <header className={classes.header}>
      <Box
        mx={4}
        className={classes.container}
        alignItems="center"
        display="flex"
        flex={1}
        justifyContent="space-between"
      >
        <a href="https://www.lifesize.com">
          <img
            className={classes.logo}
            alt="lifesize-logo"
            src="https://www.lifesize.com/wp-content/uploads/2020/12/lifesize-buddy-long-copy.svg"
          ></img>
        </a>
        <Box className={classes.needHelpContainer}>
          {intl.get('components.Header.NeedHelp')}&nbsp;
          <a className={classes.link} href="https://www.lifesize.com/en/contact-us">
            {intl.get('components.Header.ContactUs')}
          </a>
        </Box>
      </Box>
    </header>
  );
}
